import React from 'react'

import GaDivider from 'components/GaDivider'
import Stars from 'components/Stars'
import Typography from 'components/Typography'

import MethodologySubTitle from './components/MethodologySubTitle'

import classes from './FeaturesContent.module.scss'

// TODO: Just for experiment, if success, this is a responsability of the backend
const removeFeatureTitle = title => {
  const withIndex = title.indexOf('with')
  return withIndex === -1 ? title : title.substring(0, withIndex)
}
const FeaturesContent = ({ categoryName, keyFeatures }) => {
  const shortCategoryName = removeFeatureTitle(categoryName)
  const sumImportance = keyFeatures.reduce((acc, feature) => acc + parseFloat(feature.cnt_importance), 0)
  const isAIAssisted = keyFeatures.length === 2 && Object.keys(keyFeatures[0]).some(key => key === 'question')

  const hasFirstQuestion = keyFeatures[0].question && keyFeatures[0].answer

  // TODO: Just for experiment, if success, this is a responsability of the backend
  const renamedQuestion2 = isAIAssisted && keyFeatures[1].question.replace('reviewers', 'verified reviews')

  const title2 = hasFirstQuestion ? renamedQuestion2 : `Key features of ${shortCategoryName}`
  return (
    <div>
      {isAIAssisted ? (
        <>
          {hasFirstQuestion && (
            <>
              <Typography className={classes.title}>{keyFeatures[0].question}</Typography>
              <MethodologySubTitle />
              <Typography data-testid="first-answer" variant="body-sm" className={classes.description}>
                {keyFeatures[0].answer}
              </Typography>
              <GaDivider />
            </>
          )}
          <Typography className={classes.title}>{title2}</Typography>
          {!hasFirstQuestion && <MethodologySubTitle />}
          <ul className={classes.featuresList}>
            {keyFeatures[1].key_features.map(feature => (
              <li key={`key_feature_${feature.slug}`}>
                {feature.name}: {feature.definition}
              </li>
            ))}
          </ul>
        </>
      ) : (
        <>
          <Typography className={classes.title}>{shortCategoryName} Key Features</Typography>
          <ul className={classes.featuresList}>
            <span className={classes.subText}>
              {`Based on ${sumImportance} user opinions, we identified ${keyFeatures.length} features that are important for any product in ${shortCategoryName}`}
            </span>
            {keyFeatures.map(feature => (
              <li key={`key_feature_${feature.slug}`}>
                <Typography className={classes.featureName}>{feature.name}</Typography>
                <Typography variant="body-xs" className={classes.featureDefinition}>
                  {feature.definition}
                </Typography>
                <div className={classes.averageRating}>
                  <Typography variant="body-xs">Average user rating</Typography>
                  <Stars rating={feature.avg_rating} isCompact showAverageRating className={classes.starRating} />
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}

export default FeaturesContent
